
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fRK8K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fQsf7 = parcelRequire("fQsf7");

var $bkWe9 = parcelRequire("bkWe9");

$fQsf7.__exportStar((parcelRequire("bXUmy")), module.exports); /**
                                                      * InvalidAriError - an error thrown if an invalid Ari is constructed
                                                      */ 
class $b8cf98b4decd8829$var$InvalidAriError extends Error {
    static withConstraintViolations(ariString, violations) {
        return new $b8cf98b4decd8829$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString; // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $b8cf98b4decd8829$var$InvalidAriError.prototype);
    }
}
module.exports.InvalidAriError = $b8cf98b4decd8829$var$InvalidAriError;
function $b8cf98b4decd8829$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
} // constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $b8cf98b4decd8829$var$basicCharConstraint = $bkWe9.pattern(/^[a-z][a-z.-]*$/); /**
                                                                       * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
                                                                       * It's a violation of the spec, but we still need to support that.
                                                                       * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
                                                                       */ 
const $b8cf98b4decd8829$var$resourceTypeCharConstraints = $bkWe9.pattern(/^[a-z][a-z.-]*$/i);
const $b8cf98b4decd8829$var$resourceOwnerConstraints = [
    $bkWe9.lengthBetween(3, 255),
    $b8cf98b4decd8829$var$basicCharConstraint
];
const $b8cf98b4decd8829$var$resourceTypeConstraints = [
    $bkWe9.lengthBetween(3, 255),
    $b8cf98b4decd8829$var$resourceTypeCharConstraints
];
const $b8cf98b4decd8829$var$cloudIdConstraints = [
    $bkWe9.lengthBetween(3, 255)
];
const $b8cf98b4decd8829$var$siteResourceType = 'site';
const $b8cf98b4decd8829$var$resourceIdChars = /[\w-._~:@#]/.source;
const $b8cf98b4decd8829$var$resourceIdConstraints = [
    $bkWe9.pattern(new RegExp(`^${$b8cf98b4decd8829$var$resourceIdChars}+(/${$b8cf98b4decd8829$var$resourceIdChars}*)*(;v=${$b8cf98b4decd8829$var$resourceIdChars}*)*$`))
]; /**
                                                                                                                                             * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                             * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                             */ 
function $b8cf98b4decd8829$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $b8cf98b4decd8829$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $b8cf98b4decd8829$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $b8cf98b4decd8829$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    static parse(ariString) {
        if (!ariString) throw new $b8cf98b4decd8829$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $b8cf98b4decd8829$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $b8cf98b4decd8829$var$InvalidAriError(ariString);
        return new $b8cf98b4decd8829$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $b8cf98b4decd8829$var$parse(decodeURIComponent(encodedAriString));
    }
    toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $b8cf98b4decd8829$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $b8cf98b4decd8829$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    toJSON() {
        return this.toString();
    }
    equals(other) {
        return other instanceof $b8cf98b4decd8829$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    contains(other) {
        return this.matches(new $b8cf98b4decd8829$var$ResourceIdentifier(other));
    }
    matches(other) {
        return $b8cf98b4decd8829$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $b8cf98b4decd8829$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $b8cf98b4decd8829$var$siteResourceType && !!other.resourceType || $b8cf98b4decd8829$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $b8cf98b4decd8829$var$siteResourceType && !!other.resourceType || $b8cf98b4decd8829$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $b8cf98b4decd8829$var$siteResourceType && !cloudId) return new $bkWe9.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $bkWe9.validateField(this, 'resourceOwner', $b8cf98b4decd8829$var$resourceOwnerConstraints),
            $bkWe9.validateField(this, 'resourceType', $b8cf98b4decd8829$var$resourceTypeConstraints),
            $bkWe9.validateField(this, 'resourceId', $b8cf98b4decd8829$var$resourceIdConstraints),
            $bkWe9.validateField(this, 'cloudId', $b8cf98b4decd8829$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $b8cf98b4decd8829$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $b8cf98b4decd8829$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
    constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $b8cf98b4decd8829$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
}
module.exports.ResourceIdentifier = $b8cf98b4decd8829$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $b8cf98b4decd8829$var$parse(ariString) {
    return $b8cf98b4decd8829$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $b8cf98b4decd8829$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $b8cf98b4decd8829$var$parseEncoded(encodedAriString) {
    return $b8cf98b4decd8829$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $b8cf98b4decd8829$var$parseEncoded;

});
parcelRegister("bkWe9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $utZbE = parcelRequire("utZbE");
class $840ebaaa7827553e$var$LengthConstraint {
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
}
module.exports.LengthConstraint = $840ebaaa7827553e$var$LengthConstraint;
class $840ebaaa7827553e$var$RegexConstraint {
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
    constructor(regex){
        this.regex = regex;
    }
}
module.exports.RegexConstraint = $840ebaaa7827553e$var$RegexConstraint;
class $840ebaaa7827553e$var$GeneralValidationError {
    toString() {
        return this.error;
    }
    constructor(error){
        this.error = error;
    }
}
module.exports.GeneralValidationError = $840ebaaa7827553e$var$GeneralValidationError;
class $840ebaaa7827553e$var$ConstraintViolation {
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
}
module.exports.ConstraintViolation = $840ebaaa7827553e$var$ConstraintViolation;
function $840ebaaa7827553e$var$lengthBetween(min, max) {
    return new $840ebaaa7827553e$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $840ebaaa7827553e$var$lengthBetween;
function $840ebaaa7827553e$var$pattern(regex) {
    return new $840ebaaa7827553e$var$RegexConstraint(regex);
}
module.exports.pattern = $840ebaaa7827553e$var$pattern;
function $840ebaaa7827553e$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($utZbE.isDefined);
    return violatedConstraints.length > 0 ? new $840ebaaa7827553e$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $840ebaaa7827553e$var$validateField;

});

parcelRegister("bXUmy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dNjyi = parcelRequire("dNjyi");
var $8b60ecdaed5b5339$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($8b60ecdaed5b5339$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $8b60ecdaed5b5339$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $8b60ecdaed5b5339$var$AppFamilyAriError;
class $8b60ecdaed5b5339$var$NotAppFamilyAriError extends $8b60ecdaed5b5339$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $8b60ecdaed5b5339$var$NotAppFamilyAriError;
class $8b60ecdaed5b5339$var$NotExpectedAppFamilyAriTypeError extends $8b60ecdaed5b5339$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $8b60ecdaed5b5339$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $8b60ecdaed5b5339$var$parseAppAri(ari) {
    return $dNjyi.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $8b60ecdaed5b5339$var$parseAppAri;
function $8b60ecdaed5b5339$var$createAppAri(json) {
    return new $dNjyi.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $8b60ecdaed5b5339$var$createAppAri;

});
parcelRegister("dNjyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bXUmy = parcelRequire("bXUmy");

var $fRK8K = parcelRequire("fRK8K");

var $bkWe9 = parcelRequire("bkWe9");
const $a0af04a3ea56d232$var$versionPrefix = ';v=';
const $a0af04a3ea56d232$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $a0af04a3ea56d232$var$uuidConstraints = [
    $bkWe9.pattern(new RegExp(`^${$a0af04a3ea56d232$var$uuidRegExpString}$`, 'i'))
];
const $a0af04a3ea56d232$var$extensionGroupIdConstraints = [
    $bkWe9.pattern(new RegExp(`^(${$a0af04a3ea56d232$var$uuidRegExpString}|static)$`, 'i'))
];
class $a0af04a3ea56d232$var$AppFamilyAriImpl {
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $bXUmy.AppFamilyAri.resourceOwner) throw new $bXUmy.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$bXUmy.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $bXUmy.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $bXUmy.NotAppFamilyAriError(ari, `resourceType must be one of ${$bXUmy.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $bXUmy.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($a0af04a3ea56d232$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($a0af04a3ea56d232$var$versionPrefix) > versionIndex) throw new $bXUmy.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($a0af04a3ea56d232$var$versionPrefix);
        const segments = mainResourceId.split('/').map($a0af04a3ea56d232$var$stripToUndefined);
        if (segments.length > 4) throw new $bXUmy.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $bXUmy.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $bXUmy.AppFamilyAri.extensionGroupResourceType || resourceType === $bXUmy.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $bXUmy.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$bXUmy.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $bXUmy.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$bXUmy.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $bXUmy.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$bXUmy.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $bXUmy.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$bXUmy.AppFamilyAri.environmentResourceType}`);
        return new $a0af04a3ea56d232$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $bXUmy.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $bkWe9.validateField(this, 'environmentId', $a0af04a3ea56d232$var$uuidConstraints),
            $bkWe9.validateField(this, 'appId', $a0af04a3ea56d232$var$uuidConstraints),
            $bkWe9.validateField(this, 'extensionGroupId', $a0af04a3ea56d232$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $fRK8K.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $bXUmy.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$a0af04a3ea56d232$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
    constructor(json){
        this.json = json;
        this.validate();
    }
}
module.exports.AppFamilyAriImpl = $a0af04a3ea56d232$var$AppFamilyAriImpl;
function $a0af04a3ea56d232$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




//# sourceMappingURL=root-component.a110db48.js.map
